import * as THREE from 'three'
import Scene from '../index.js'

class Renderer
{
    constructor()
    {
        this.dom = Scene.dom
        this.sizes = Scene.sizes
        this.scene = Scene.instance
        this.camera = Scene.camera

        this.setInstance()
    }

    setInstance()
    {
        this.instance = new THREE.WebGLRenderer({
            canvas: this.dom,
            antialias: true
        })
        this.instance.setClearColor('#211d20')
        this.instance.setSize(this.sizes.width, this.sizes.height)
        this.instance.setPixelRatio(Math.min(this.sizes.pixelRatio, 2))
    }

    resize()
    {
        this.instance.setSize(this.sizes.width, this.sizes.height)
        this.instance.setPixelRatio(Math.min(this.sizes.pixelRatio, 2))
    }

    update()
    {
        this.instance.render(this.scene, this.camera.instance)
    }
}

export default Renderer